import {ReactNode} from 'react';

import {HoverableBox} from './HoverableBox';

interface HoverableBackgroundProps {
  children: ReactNode;
}

export function HoverableBackground(props: HoverableBackgroundProps) {
  return (
    <HoverableBox borderRadius="small" hoverBackgroundColor="palettes.neutral.10.100">
      {props.children}
    </HoverableBox>
  );
}
